import React, { useState } from "react";

import DatePicker, { registerLocale } from "react-datepicker";
import es from 'date-fns/locale/es';
import "react-datepicker/dist/react-datepicker.css";
import './CustomDatePicker.css';

registerLocale('es', es)

interface DatePickerProps {
    onDateChange: any
}

const CustomDatePicker = ({ onDateChange }: DatePickerProps) => {
    const [dateRange, setDateRange] = useState<[Date | null, Date | null]>([null, null]);
    const [dateStart, dateEnd] = dateRange;

    const onRangeChange = ([dateStart, dateEnd]: [Date | null, Date | null], isReset: boolean) => {
        if (isReset) {
            onDateChange({ dateStart: 0, dateEnd: 0 })

            return;
        }
        if (dateStart && dateEnd) {
            onDateChange({ dateStart: dateStart.getTime(), dateEnd: dateEnd.getTime() })
        }
    }

    return (
        <div className="row custom-datepicker">
            <div className="col-lg-4 col-md-4 col-sm-12 col-12">
                <DatePicker
                    locale="es"
                    selected={dateStart}
                    onChange={(update) => {
                        setDateRange(update);
                        onRangeChange(update, false);
                    }}
                    startDate={dateStart}
                    endDate={dateEnd}
                    selectsRange
                    customInput={<button className="btn btn-custom">Seleccionar fechas</button>}
                />
            </div>
            <div className="col-lg-4 col-md-4 col-sm-12 col-12 mb-2 mt-2  text-center">
                {(dateStart && dateEnd) ?
                    <>
                        <h6>Fechas seleccionadas</h6>
                        {new Intl.DateTimeFormat('es-MX').format(dateStart)} - {new Intl.DateTimeFormat('es-MX').format(dateEnd)}
                    </>
                    : 'No hay fechas seleccionadas'}
            </div>
            <div className="col-lg-4 col-md-4 col-sm-12 col-12 text-center">
                <button className="btn btn-custom" onClick={() => {
                    setDateRange([null, null]);
                    onRangeChange([null, null], true);
                }}>Resetear</button>
            </div>
        </div>
    );
}

export default CustomDatePicker;